<template>
    <BlocoAccordion
        titulo="Estratégico"
        tema="estrategico"
        subtitulo="On Time"
        descricao="Entregas no prazo a partir das propostas comerciais"
        :aberto-inicial="true"
    >
        <div v-if="carregando" class="loading kpis-loading"><div></div></div>
        <div v-else-if="resumo" class="otif-kpis">
            <div
                class="kpi kpi-desabilitado"
                title="OTIF depende de In Full — dados ainda não disponíveis"
                aria-disabled="true"
            >
                <span class="kpi-label">OTIF médio</span>
                <strong class="kpi-valor kpi-indisponivel">Indisponível</strong>
            </div>
            <div class="kpi">
                <span class="kpi-label">Meta</span>
                <strong class="kpi-valor">{{ meta }}%</strong>
            </div>
            <div class="kpi">
                <span class="kpi-label">Gap On Time vs meta</span>
                <strong class="kpi-valor" :class="classeGap">
                    {{ resumo.gapMeta > 0 ? '+' : '' }}{{ resumo.gapMeta }} pp
                </strong>
            </div>
            <button
                type="button"
                class="kpi kpi-clicavel"
                :class="{ destacado: modoComponentes === 'onTime' }"
                title="Ver gráfico só de On Time"
                @click="definirModoComponentes('onTime')"
            >
                <span class="kpi-label">On Time</span>
                <strong class="kpi-valor">{{ formatarPercentual(resumo.mediaOnTime) }}</strong>
            </button>
            <div
                class="kpi kpi-desabilitado"
                title="Dados de quantidade entregue ainda indisponíveis"
                aria-disabled="true"
            >
                <span class="kpi-label">In Full</span>
                <strong class="kpi-valor kpi-indisponivel">Indisponível</strong>
            </div>
            <div class="kpi">
                <span class="kpi-label">Pedidos avaliados</span>
                <strong class="kpi-valor">{{ resumo.pedidosAvaliados }}</strong>
            </div>
        </div>

        <p class="aviso-parcial">
            <i class="bi bi-info-circle" aria-hidden="true"></i>
            On Time com dados reais das propostas comerciais. In Full e OTIF Geral ainda não disponíveis.
        </p>

        <OtifGeral
            :mes="mes"
            :ano="ano"
            :motivo-indisponivel="motivoOtif"
            @updateMes="atualizarMes"
        />
        <OtifComponentes
            :mes="mes"
            :ano="ano"
            :modo-inicial="modoComponentes"
            :motivo-in-full="motivoInFull"
            @updateMes="atualizarMes"
            @update:modo="modoComponentes = $event"
        />
    </BlocoAccordion>
</template>

<script>
import BlocoAccordion from './BlocoAccordion.vue';
import OtifGeral from './Graficos/Estrategico/OtifGeral.vue';
import OtifComponentes from './Graficos/Estrategico/OtifComponentes.vue';
import serviceGraficos from '@/services/serviceGraficos.js';

export default {
    name: 'BlocoEstrategico',
    components: {
        BlocoAccordion,
        OtifGeral,
        OtifComponentes,
    },
    props: {
        mes: { required: true },
        ano: { required: true },
    },
    emits: ['updateMes'],
    data() {
        return {
            resumo: null,
            meta: 95,
            carregando: true,
            modoComponentes: 'onTime',
            motivoOtif: 'Indicador OTIF depende de In Full — dados ainda não disponíveis',
            motivoInFull: 'Dados de quantidade entregue ainda indisponíveis',
        };
    },
    computed: {
        classeGap() {
            if (!this.resumo) return '';
            return this.resumo.gapMeta >= 0 ? 'positivo' : 'negativo';
        },
    },
    watch: {
        mes: 'carregarResumo',
        ano: 'carregarResumo',
    },
    mounted() {
        this.carregarResumo();
    },
    methods: {
        formatarPercentual(valor) {
            if (valor == null || Number.isNaN(Number(valor))) return '—';
            return `${valor}%`;
        },
        async carregarResumo() {
            this.carregando = true;
            try {
                const dados = await serviceGraficos.getOtif(this.mes, this.ano);
                this.resumo = dados.resumo;
                this.meta = dados.meta;
                this.motivoOtif = dados.motivoOtif;
                this.motivoInFull = dados.motivoInFull;
            } catch (error) {
                console.error('Erro ao carregar resumo On Time:', error);
                this.resumo = null;
            } finally {
                this.carregando = false;
            }
        },
        definirModoComponentes(modo) {
            if (modo === 'inFull') return;
            this.modoComponentes = this.modoComponentes === modo ? 'onTime' : modo;
        },
        atualizarMes(mes) {
            this.$emit('updateMes', mes);
        },
    },
};
</script>

<style scoped>
.otif-kpis {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 0.75rem;
    padding: 1rem 1rem 0.25rem;
}

.kpi {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    padding: 0.75rem 0.85rem;
    border-radius: 10px;
    background: color-mix(in srgb, #5b4fcf 10%, var(--cor-bg));
    box-shadow: 0 0 0 1px color-mix(in srgb, #5b4fcf 22%, transparent) inset;
}

.kpi-clicavel {
    border: none;
    text-align: left;
    cursor: pointer;
    font: inherit;
    color: inherit;
    transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.kpi-clicavel:hover {
    transform: translateY(-1px);
    box-shadow: 0 0 0 1px #5b4fcf inset;
}

.kpi-clicavel.destacado {
    background: color-mix(in srgb, #5b4fcf 18%, var(--cor-bg));
    box-shadow: 0 0 0 2px #5b4fcf inset;
}

.kpi-desabilitado {
    opacity: 0.55;
    background: color-mix(in srgb, #6b7280 10%, var(--cor-bg));
    box-shadow: 0 0 0 1px color-mix(in srgb, #6b7280 25%, transparent) inset;
    cursor: not-allowed;
}

.kpi-label {
    font-size: 0.75rem;
    opacity: 0.75;
}

.kpi-valor {
    font-size: 1.15rem;
    line-height: 1.2;
}

.kpi-valor.positivo {
    color: var(--cor-sucesso);
}

.kpi-valor.negativo {
    color: var(--cor-erro);
}

.kpi-indisponivel {
    font-size: 0.95rem;
    opacity: 0.85;
}

.aviso-parcial {
    margin: 0.75rem 1rem 0;
    padding: 0.55rem 0.75rem;
    font-size: 0.8rem;
    border-radius: 8px;
    background: color-mix(in srgb, #3571cd 10%, var(--cor-bg));
    box-shadow: 0 0 0 1px color-mix(in srgb, #3571cd 25%, transparent) inset;
    color: inherit;
    display: flex;
    align-items: center;
    gap: 0.45rem;
}

.kpis-loading {
    margin: 1rem;
}

@media (max-width: 640px) {
    .otif-kpis {
        grid-template-columns: repeat(2, 1fr);
    }
}
</style>
